import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'
import type { DiffEntry } from '@/modules/shared/utils/diff'

type State = {
  isDirty: boolean
  diffEntries: DiffEntry[]
}

type Actions = {
  setDirty: (dirty: boolean, diffEntries?: DiffEntry[]) => void
}

export const useDirtyStore = create<State & Actions>()(
  devtools(
    zustandPlugin((set) => ({
      isDirty: false,
      diffEntries: [],
      setDirty: (isDirty, diffEntries = []) =>
        set({ isDirty, diffEntries: isDirty ? diffEntries : [] }, false, 'setDirty'),
    }), 'dirty'),
    { name: 'EasyTacho', store: 'dirty' },
  ),
)
